import React, { useEffect, useMemo } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { ISCMPurchaseDetailsDetail } from "../purchaseDetailsService";
import { useStockPoDetailModel } from "../purchaseDetailsModel";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

export function DataTable() {
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const {
        dataSource, selectedRowKeys, pgCfg, initPgCfg, statistics,
        loadData, setSelectedRowKeys,
        setOccupyStockModel,
    } = useStockPoDetailModel();

    useEffect(() => {
        loadData();
    }, [])

    const defaultColumns: ColumnsType<ISCMPurchaseDetailsDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 66,
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '商品编码',
            width: 180,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '仓库名称',
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            title: '仓库编号',
            width: 180,
            dataIndex: 'warehouseCode',
        }, {
            title: '货位编号',
            width: 160,
            dataIndex: 'shelfCode',
        },
        // {
        //     title: '初始库存数量',
        //     width: 100,
        //     dataIndex: 'inventoryInitial',
        // }, 
        {
            title: '库存数量',
            width: 120,
            dataIndex: 'inventoryNum',
        }, {
            title: '占用库存数量',
            width: 110,
            dataIndex: 'inventoryOccupied',
            render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title="占用库存查看"><p className="ellipsis click-span" onClick={(e) => {
                e.stopPropagation();
                setOccupyStockModel(record);
                return;

            }}>{text}</p></Tooltip>,
        }, {
            title: '可用库存数量',
            width: 110,
            dataIndex: 'availableStock',
        }, {
            title: '入库数量',
            width: 100,
            dataIndex: 'num',
        },
        {
            title: '入库单价',
            width: 100,
            dataIndex: 'latestPurPrice',
            render: (text) => text ? '￥' + text : '￥0',

        }, {
            title: '入库金额',
            width: 100,
            dataIndex: 'amount',
            render: (text) => text ? '￥' + text : '￥0',

        }, {
            title: '库存金额',
            width: 140,
            dataIndex: 'totalAmount',
            render: (text) => text ? '￥' + text : '￥0',

        }, {
            title: '最近销价',
            width: 100,
            dataIndex: 'lateSalePrice',
            render: (text) => text ? '￥' + text : '￥0',

        },
        {
            title: '供应商编号',
            width: 240,
            dataIndex: 'supplierCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '供应商名称',
            width: 210,
            dataIndex: 'supplierName',
        }, {
            title: '采购单号',
            width: 210,
            dataIndex: 'purchaseCode',
        }, {
            title: '入库日期',
            width: 160,
            dataIndex: 'stockIoTime',
        }, {
            title: '替换编号',
            width: 160,
            dataIndex: 'replaceCode',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "stockDetail", "roleCodes": roles };
        return getRoleColumns("stockDetail", "主单", defaultColumns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            rowKey={record => record.id}
            // rowSelection={{
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: ISCMPurchaseDetailsDetail[]) => {
            //         setSelectedRowKeys(selectedRowKeys as string[]);
            //     }
            // }}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 370px)" }}
            summary={() => (
                <Table.Summary fixed>
                    <Table.Summary.Row className="table-total-box">
                        <Table.Summary.Cell index={0}>
                            <div className="title">合计</div>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1} />
                        <Table.Summary.Cell index={2} />
                        <Table.Summary.Cell index={3} />
                        <Table.Summary.Cell index={4} />
                        <Table.Summary.Cell index={5} />
                        <Table.Summary.Cell index={6} />
                        <Table.Summary.Cell index={7} />
                        <Table.Summary.Cell index={8}>
                            <span className="red">{statistics?.stockNum ?? 0}</span>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={9} />
                        <Table.Summary.Cell index={10} />
                        <Table.Summary.Cell index={11} />
                        <Table.Summary.Cell index={12} />
                        <Table.Summary.Cell index={13} />
                        {/* <Table.Summary.Cell index={14}>
                            <span className="red">{statistics?.stockAmount ?? 0}</span>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell index={14} />
                        <Table.Summary.Cell index={15} />
                        <Table.Summary.Cell index={16} />
                        <Table.Summary.Cell index={17} />
                        <Table.Summary.Cell index={18} />
                        <Table.Summary.Cell index={19} />
                        <Table.Summary.Cell index={20} />
                        <Table.Summary.Cell index={21} />
                    </Table.Summary.Row>
                </Table.Summary>
            )}
        />
    )
}
